import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import { formatApiError } from "../lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (event) => {
    event.preventDefault(); setErr(""); setLoading(true);
    try { await login(email, password, rememberMe); nav("/"); }
    catch (error) { setErr(formatApiError(error.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return <main className="flex min-h-[100dvh] items-center justify-center overflow-x-hidden bg-slate-50 px-4 py-8 sm:px-6" data-testid="login-auth-panel">
    <div className="w-full max-w-md" data-testid="login-auth-group">
      <div className="mb-7 text-center" aria-label="Webstax">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-slate-950 text-lg font-black text-white shadow-sm" aria-hidden="true">W</div>
        <p className="mt-3 font-chivo text-xl font-black tracking-tight">WEBSTAX</p>
        <p className="mt-1 text-sm text-slate-500">One secure account for your Webstax workspace</p>
      </div>
      <form onSubmit={submit} className="w-full rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8" data-testid="login-form">
        <h1 className="font-chivo text-2xl font-black">Welcome back</h1>
        <p className="mt-1 text-sm text-slate-500">Sign in to continue.</p>
        <label htmlFor="login-email" className="mt-6 block text-sm font-semibold text-slate-700">Email</label>
        <input id="login-email" data-testid="login-email-input" autoComplete="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="mt-1.5 w-full rounded-lg border border-slate-300 px-3 py-2.5 outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100" required />
        <label htmlFor="login-password" className="mt-4 block text-sm font-semibold text-slate-700">Password</label>
        <input id="login-password" data-testid="login-password-input" autoComplete="current-password" type="password" value={password} onChange={e => setPassword(e.target.value)} className="mt-1.5 w-full rounded-lg border border-slate-300 px-3 py-2.5 outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100" required />
        <label className="mt-4 flex min-h-11 items-center gap-3 text-sm text-slate-700"><input data-testid="login-remember-input" type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} className="h-4 w-4"/><span>Keep me signed in on this device</span></label>
        {err && <div role="alert" className="mt-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{err}</div>}
        <button type="submit" disabled={loading} className="mt-5 w-full rounded-lg bg-slate-950 px-4 py-3 font-semibold text-white disabled:opacity-50">{loading ? "Signing in…" : "Sign in"}</button>
      </form>
      <p className="mt-6 text-center text-xs text-slate-500">© 2026 Webstax Lutions LTD. All rights reserved.</p>
    </div>
  </main>;
}
